<template>
<div class="container">
    <div class="top-banner">
        <swiper :options="bannerOption">
            <swiper-slide><img src="@/assets/connect/banner.jpg" alt=""></swiper-slide>
            <!-- <swiper-slide><img src="@/assets/connect/banner.jpg" alt=""></swiper-slide>
            <swiper-slide><img src="@/assets/connect/banner.jpg" alt=""></swiper-slide> -->
        </swiper>
        <!-- <div class="swiper-pagination"></div>
        <div class="swiper-icon swiper-right"></div>
        <div class="swiper-icon swiper-left"></div> -->
    </div>
    <!--关注我们-->
    <div ref="gzwm" class="page-content bg-1">
        <div class="block-title"><img src="@/assets/connect/title_Follow Us.png" alt=""></div>
        <div class="page-card">
            <div class="card-top">
                <div class="flex-item pr0">
                    <div class="flex-item-top">
                        <i class="item-flag"><img src="@/assets/icon/icon_call.png" alt="" srcset=""></i>
                        <span class="item-title">全国免费服务热线：</span>
                    </div>
                    <div class="flex-item-text">400-070-2717</div>
                </div>
                <div class="flex-item pr0">
                    <div class="flex-item-top">
                        <i class="item-flag"><img src="@/assets/icon/icon_Email.png" alt="" srcset=""></i>
                        <span class="item-title">媒体采访：</span>
                    </div>
                    <div class="flex-item-text">{{ cardData.mrEmail }}</div>
                </div>
                <div class="flex-item p0">
                    <div class="flex-item-top">
                        <i class="item-flag"><img src="@/assets/icon/icon_Email.png" alt="" srcset=""></i>
                        <span class="item-title">媒体合作：</span>
                    </div>
                    <div class="flex-item-text">{{ cardData.prEmail }}</div>
                </div>
                <div class="flex-item b-left join-wrap">
                    <div class="join-title"><img src="@/assets/connect/Join_us.png" alt=""></div>
                    <div class="join-btn" @click="goJoinUs">点击加入我们<i class="join-to-sign"></i></div>
                </div>
                <!-- <div class="flex-img"><img src="@/assets/brand/img_IPmin_1.png" alt=""></div> -->
            </div>
            <ul class="card-content">
                <li class="card-item">
                    <div class="card-item-img"><img src="@/assets/icon/Follow_douyin.png" alt=""></div>
                    <div class="card-item-qrcode b-right"><img src="@/assets/icon/douyin-code.png" alt=""></div>
                    <div class="card-item-text">扫一扫关注抖音</div>
                </li>
                <li class="card-item">
                    <div class="card-item-img"><img src="@/assets/icon/Follow_weibo.png" alt=""></div>
                    <div class="card-item-qrcode b-right"><img src="@/assets/icon/weibo-code.jpg" alt=""></div>
                    <div class="card-item-text">扫一扫关注微博</div>
                </li>
                <li class="card-item">
                    <div class="card-item-img"><img src="@/assets/icon/Follow_wechat.png" alt=""></div>
                    <div class="card-item-qrcode b-right"><img src="@/assets/icon/weixin-code.png" alt=""></div>
                    <div class="card-item-text">扫一扫关注公众号</div>
                </li>
                <li class="card-item">
                    <div class="card-item-img"><img style="width: 90px;height: 90px;" src="@/assets/icon/jianli.png" alt=""></div>
                    <div class="card-item-qrcode b-right"><img src="@/assets/icon/jianli-code.png" alt=""></div>
                    <div class="card-item-text">扫一扫投递简历</div>
                </li>
                <li class="card-item">
                    <div class="card-item-img"><img src="@/assets/icon/Follow_xiaohongshu.png" alt=""></div>
                    <div class="card-item-qrcode"><img src="@/assets/icon/xhs-code.jpg" alt=""></div>
                    <div class="card-item-text">扫一扫关注小红书</div>
                </li>
            </ul>
        </div>
    </div>
    <!--公司地址-->
    <!-- <div ref="gsdz" class="page-content bg-2">
        <div class="block-title"><img src="@/assets/connect/title_location.png" alt=""></div>
        <div class="page-addr-wrap">
            <div class="addr-wrap">
                <div class="addr-content">
                    <div class="addr-left">
                        <p class="addr-title">公司地址</p>
                        <p class="addr-entitle">COMPANY ADDRESS</p>
                    </div>
                    <ul class="addr-list">
                        <li class="addr-item top-addr">
                            <div class="addr-name">总部公司地址</div>
                            <div class="addr-detail">江西宜春市袁州区汉卿楼</div>
                        </li>
                        <li class="addr-item" v-for="(item,index) in addrList" :key="index">
                            <div class="addr-name">{{ item.name }}</div>
                            <div class="addr-detail">{{ item.addr }}</div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="map-content">
                <baidu-map class="bm-view" :center="center" :zoom="16" :scroll-wheel-zoom="true" ak="3xX85VgvRQeVWbF6RhWN3SdxLXY6XKlv">
                    <bm-marker :position="center" :dragging="true"></bm-marker>
                    <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
                    <bm-info-window :position="center" title="" :show="infoWindow.show" @close="infoWindowClose" @open="infoWindowOpen">
                        <div class="map-window">
                            <p class="window-title">宜春市赵一鸣商贸有限公司</p>
                            <p class="window-text">地址：江西省宜春市袁州区汉卿楼</p>
                            <p class="window-text">电话：400-070-2717</p>
                        </div>
                    </bm-info-window>
                </baidu-map>
            </div>
        </div>
    </div> -->
    <!--投诉与建议-->
    <div ref="tsjy" class="page-content bg-3 pt0">
        <div class="block-title"><img src="@/assets/connect/title_complaint.png" alt=""></div>
        <div class="sugg-form">
            <div class="form-item">
                <div class="form-title">联系人</div>
                <div class="form-entitle">Contact person</div>
                <div class="form-input">
                    <input type="text" v-model="formData.contactName" placeholder="填写您的名字">
                </div>
                <div v-show="showUserWarn" class="warn-text">联系人不能为空</div>
            </div>
            <div class="form-item">
                <div class="form-title">联系方式</div>
                <div class="form-entitle">Contact information</div>
                <div class="form-input">
                    <input type="text" v-model="formData.contactPhone" placeholder="填写您的联系电话">
                </div>
                <div v-show="showPhoneWarn" class="warn-text">联系方式格式不正确</div>
            </div>
            <div class="form-item wid-100">
                <div class="form-title">改善意见</div>
                <div class="form-entitle">Suggestions for improvement</div>
                <div class="form-input">
                    <textarea name="" id="" rows="10" v-model="formData.content" placeholder="填写您的改善意见，您的建议和意见，鸣宝都会聆听和改进！"></textarea>
                </div>
                <div v-show="showContentWarn" class="warn-text">请填写改善意见</div>
            </div>
            <div class="form-btn wid-100">
                <button type="button" @click="showPrivacyDialog = true">提交意见</button>
            </div>
        </div>
    </div>
    <!--消息提示-->
    <div :class="isShowMsg ? 'msg-wrap active':'msg-wrap'">您好，提交成功，客服人员会在1-3个工作日内联系您！</div>


    <div v-if="showPrivacyDialog" class="privacy-dialog">
        <div class="privacy-dialog-content">
            <iframe class="privacy-iframe" src="https://server.zymls.com/privacyPolicy.html" frameborder="0"></iframe>
            <div class="privacy-options">
                <label class="privacy-checkbox">
                    <input type="checkbox" v-model="isPrivacyChecked">
                    
                    <span>我已阅读并同意隐私政策</span>
                </label>
                <div>
                    <button  @click="showPrivacyDialog = false">取消</button>
                    <button :disabled="!isPrivacyChecked" @click="submitForm">提交意见</button>
                </div>
                
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
    import bmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
    import bmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow.vue'
    import bmNavigation from 'vue-baidu-map/components/controls/Navigation.vue'
    export default {
        components: {
            BaiduMap,
            bmMarker,
            bmInfoWindow,
            bmNavigation
        },
        data(){
            return {
                showPrivacyDialog: false,
                isPrivacyChecked: false,
                bannerOption:{
                    effect: 'slide',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop:false,
                    // autoplay:{
                    //     delay:3000,
                    //     disableOnInteraction: false,
                    // },
                    navigation: {
                        nextEl: '.swiper-left',
                        prevEl: '.swiper-right',
                    },
                    pagination: {
                        clickable:true,
                        el: '.swiper-pagination'
                    }
                },
                center:{lng: 114.455824, lat: 27.811554},
                infoWindow: {
                    show: true,
                    contents: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
                },
                addrList:[
                    {name:'芜湖公司地址',addr:'安徽省芜湖市弋江区金鹰世界写字楼A座2808'},
                    {name:'广州公司地址',addr:'广东广州市番禺区启迪数字大厦B座23楼'},
                    {name:'河南公司地址',addr:'河南省郑州市金水区建业智慧港D座5楼'},
                    {name:'山东公司地址',addr:'山东省济南市槐荫区润华乾泰大厦5楼502室'},
                ],
                formData:{
                    contactName:'',
                    contactPhone:'',
                    content:''
                },
                showUserWarn:false,
                showPhoneWarn:false,
                showContentWarn:false,
                isSubmit:false,
                isShowMsg:false,
                cardData:{
                    hrEmail:'https://hnlshm3.zhiye.com',
                    mrEmail:'mmhm-pr@hnlshm.com',
                    prEmail:'lihongxiang@hnlshm.com',
                    joinLink:'https://hnlshm3.zhiye.com'
                }
            }
        },
        watch:{
            $route(to,from){
                if(to.query.block){
                    this.linkPos();
                }
            }
        },
        mounted(){
            this.getData();
            this.linkPos();
        },
        methods:{
            infoWindowClose (e) {
                this.infoWindow.show = false
            },
            infoWindowOpen (e) {
                this.infoWindow.show = true
            },
            validateUser(){
                this.showUserWarn = this.formData.contactName ? false : true;
            },
            validaterRemark(){
                this.showContentWarn = this.formData.content ? false : true;
            },
            validatePhone(){
                var reg =/^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
                this.showPhoneWarn = !reg.test(this.formData.contactPhone) ? true : false
            },
            submitForm(){
                this.showPrivacyDialog = false
                this.validateUser(); 
                this.validaterRemark(); 
                this.validatePhone();
                if(!this.showUserWarn && !this.showContentWarn && !this.showPhoneWarn){
                    const url = this.$WEBSITE_URL_OBJECT.feedback;
                    let params = {
                        contactName:this.formData.contactName,
                        contactPhone:this.formData.contactPhone,
                        content:this.formData.content
                    }
                    this.isSubmit = true;
                    this.$axios.post(url,params).then(res=>{
                        if(res.data.code === 0){
                            this.isShowMsg = true;
                            setTimeout(()=>{
                                this.isShowMsg = false;
                            },2000);
                        }
                    }).finally(()=>{
                        this.isSubmit = false;
                        this.formData = {
                            contactName:'',
                            contactPhone:'',
                            content:''
                        }
                    })
                }
            },
            linkPos(){
                const route = this.$route;
                const ref = route.query.block;
                if(ref){
                    const el = this.$refs[ref]
                    el.scrollIntoView(); 
                }
            },
            getData(){
                const url = this.$WEBSITE_URL_OBJECT.osconfig;
                this.$axios.get(url).then(res=>{
                    const {data} = res.data;
                    if(res.data.code === 0){
                        // this.cardData = {
                        //     hrEmail:data.hrEmail,
                        //     mrEmail:data.mrEmail,
                        //     prEmail:data.prEmail,
                        //     joinLink:data.joinLink
                        // }
                    }
                })
            },
            goJoinUs(){
                window.open(this.cardData.joinLink,'_blank')
            }
        }
    }
</script>
<style scoped src="./index.css">


</style>

<style scoped>
.privacy-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 11;
}
.privacy-dialog-content {
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    width: 80%;
    max-width: 800px;
    height: 80%;
    max-height: 600px;
    display: flex;
    flex-direction: column;
    padding: 20px; 
}
.privacy-iframe {
    flex-grow: 1;
    border: none;
}
.privacy-options {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.privacy-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    
}
.privacy-checkbox input {
    margin-right: 8px;
}
.privacy-checkbox .checkmark {
    width: 16px;
    height: 16px;
    border: 1px solid #000;
    display: inline-block;
}
.privacy-options button {
    padding: 8px 16px;
    background-color: #e60012;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
.privacy-options button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}
</style>


// WEBPACK FOOTER //
// src/view/connect/index.vue